import useAxiosInterceptor from 'src/services/interceptor';
import { therapyPlanningPaths } from '../constants';

class PatientScreeningService {
  private axiosInstance;

  constructor() {
    this.axiosInstance = useAxiosInterceptor();
  }

  getTherapyPlanning = (payload: any) => {
    return this.axiosInstance.get(
      `${therapyPlanningPaths.therapyPlanning}v2/${payload?.patientId}`,
      {
        params: payload?.params,
        cancelToken: payload?.abortToken,
      }
    );
  };
  getIsTherapyPlanningPatient = (payload: any) => {
    return this.axiosInstance.get(
      `${therapyPlanningPaths.therapyPlanning}eligible-for-planning/${payload?.patientId}`
    );
  };

  checkTherapyPlanningPatient = (payload: any) => {
    return this.axiosInstance.get(
      `${therapyPlanningPaths.therapyPlanning}future-plan-minutes/${payload?.patientId}?anticipatedDischargeDate=${payload?.dischargeDate}&discipline=${payload?.type}`
    );
  };

  checkTherapyPlanningPatient_v2 = (payload: any) => {
    return this.axiosInstance.get(
      `${therapyPlanningPaths.therapyPlanningV2}future-plan-minutes/${payload?.patientId}?anticipatedDischargeDate=${payload?.dischargeDate}&discipline=${payload?.type}`
    );
  };

  getDateOfService = (payload: any) => {
    return this.axiosInstance.get(`provider/patient/latest-dos/${payload?.patientId}`);
  };
  getCaseMixGroup = () => {
    return this.axiosInstance.get(`provider/facility/v2/case-mix-group`);
  };

  getTherapyPlanningPatient = (payload: any) => {
    return this.axiosInstance.get(`provider/patient/v2/all/therapy-plan`, {
      params: payload?.params,
    });
  };

  updateTherapyPlanning = (payload: any) => {
    return this.axiosInstance.put(
      `${therapyPlanningPaths.therapyPlanning}/${payload?.patientId}?providerId=${payload?.providerId}`,
      payload?.data
    );
  };

  updateTherapyPlanningDischargeDate = (payload: any) => {
    const { patientId, providerId, ...restPayload } = payload;

    return this.axiosInstance.put(
      `${therapyPlanningPaths.therapyPlanning}set-discharge-date/${patientId}?providerId=${providerId}`,
      restPayload
    );
  };

  getMDSAassessment = (payload: any) => {
    return this.axiosInstance.get(`${therapyPlanningPaths.mdsAssessment}/${payload?.patientId}`);
  };
  getAassessment = (payload: any) => {
    return this.axiosInstance.get(
      `${therapyPlanningPaths.mdsAssessment}${therapyPlanningPaths.patientId}/${payload?.patientId}`
    );
  };
  getPlanOfCare = (payload: any) => {
    return this.axiosInstance.get(`${therapyPlanningPaths.planOfCare}/${payload?.patientId}`);
  };
  createAssessment = (payload: any) => {
    return this.axiosInstance.post(
      `${therapyPlanningPaths.mdsAssessment}/${payload?.patientId}/${payload?.moduleType}`,
      payload?.data
    );
  };
  updateAssessment = (payload: any) => {
    return this.axiosInstance.put(
      `${therapyPlanningPaths.mdsAssessment}/${payload?.patientId}/${payload?.moduleType}`,
      payload?.data
    );
  };

  getCptCodeByDiscipline = (payload: any) => {
    return this.axiosInstance.get(
      `${therapyPlanningPaths.cptCodeByDiscipline}/${payload?.patientId}`
    );
  };

  editAuthorization = (payload: any) => {
    return this.axiosInstance.put(`${therapyPlanningPaths.editAuth}`, payload);
  };

  getAuthDetails = (payload: any) => {
    return this.axiosInstance.get(`${therapyPlanningPaths.authDetails}/${payload?.patientId}`);
  };

  getMultipleMdsAssessment = (payload: any) => {
    return this.axiosInstance.get(`${therapyPlanningPaths.multipleMDS}/${payload?.patientId}`);
  };

  validateCsvMdsFile = (payload: any) => {
    return this.axiosInstance.post(therapyPlanningPaths.mdsValidate, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  };
  uploadCSVTemplateMds = (payload: any) => {
    return this.axiosInstance.post(`${therapyPlanningPaths.mdsValidate}/upload`, payload);
  };

  //therapyPlanning 2.0
  getTherapyPlanningOfPatient_2_0 = (payload: any) => {
    return this.axiosInstance.get(therapyPlanningPaths.getTherapyPlaning_2_0(payload?.patientId), {
      params: payload?.params,
      cancelToken: payload?.abortToken,
    });
  };

  getTherapyPlanningSummary = (payload: any) => {
    return this.axiosInstance.get(
      therapyPlanningPaths.getTherapyPlaningSummary(payload?.patientId),
      {
        params: payload?.params,
        cancelToken: payload?.abortToken,
      }
    );
  };

  editSingleCellOfTherapyPlanning = (payload: any) => {
    return this.axiosInstance.post(
      `${therapyPlanningPaths.editSingleCell(payload?.patientId)}`,
      payload?.params
    );
  };

  updateTherapyPlanningUncoveredDay = (payload: any) => {
    return this.axiosInstance.put(
      therapyPlanningPaths.updateUncoveredDay(payload?.patientId),
      null,
      {
        params: payload?.params,
      }
    );
  };

  getDischargeDatesOfTherapyPlanning = (payload: any) => {
    return this.axiosInstance.get(therapyPlanningPaths.getDischarges(payload?.patientId));
  };

  copyPasteTherapyPlanning = (payload: any) => {
    return this.axiosInstance.put(therapyPlanningPaths.copyTherapyWeek(payload?.patientId), null, {
      params: payload.params,
    });
  };

  applyTherapyTemplates = (payload: any) => {
    return this.axiosInstance.put(
      therapyPlanningPaths.applyTheTemplates(payload?.patientId),
      null,
      {
        params: payload.params,
      }
    );
  };

  getAllTemplates = (payload: any) => {
    return this.axiosInstance.get(therapyPlanningPaths.getAllTherapyPlanningTemplates, {
      params: payload?.params,
    });
  };

  createNewTherapyTemplates = (payload: any) => {
    return this.axiosInstance.post(`provider/therapy-planning-template`, payload);
  };

  editTherapyTemplates = (payload: any) => {
    return this.axiosInstance.put(`provider/therapy-planning-template/${payload?.uuid}`, {
      templateName: payload?.templateName,
      content: payload?.content,
    });
  };

  deleteTherapyTemplates = (payload: any) => {
    return this.axiosInstance.delete(`provider/therapy-planning-template/${payload?.uuid}`);
  };

  getMdsAssessmentRange = (payload: any) => {
    return this.axiosInstance.get(therapyPlanningPaths.getMdsRange(payload?.patientId), {
      params: {
        ...payload?.params,
      },
    });
  };

  getSingleMdsAssessment = (payload: any) => {
    return this.axiosInstance.get(therapyPlanningPaths.getSingleMds(payload.mdsAssessmentId));
  };

  deleteMdsAssessmentByDate = (payload: any) => {
    return this.axiosInstance.delete(therapyPlanningPaths.deleteMdsByDate(payload?.patientId), {
      params: payload?.param,
    });
  };

  deleteSingleMds = (payload: any) => {
    return this.axiosInstance.delete(therapyPlanningPaths.deleteSingleMds(payload?.mdsId));
  };

  get7DayLookBack = (payload: any) => {
    return this.axiosInstance.get(therapyPlanningPaths.get7DayLookBack(payload?.patientId), {
      params: payload?.params,
      cancelToken: payload?.abortToken,
    });
  };
}

const patientScreeningService = new PatientScreeningService();

Object.freeze(patientScreeningService);

export default patientScreeningService;
